import React from "react";
import {
  TableBlock,
  WiseOwlElementIds,
} from "@twiliointernal/e2-commons-shared-definitions";
import { TBody, THead, Table, Td, Tr, Th } from "@twilio-paste/core/table";

interface TableProps {
  block: TableBlock;
}

const TableRenderer: React.FC<TableProps> = ({ block }) => {
  /**
   * Properties that end in "_span" are used for presentational purposes
   * with the rowSpan attribute. Any remaining properties are used as
   * column headers.
   */
  const SPAN_SUFFIX = "_span";
  const { records } = block.values;
  const columns = Object.keys(records[0]).filter(
    (key) => !key.endsWith(SPAN_SUFFIX)
  );

  return (
    <Table
      noWrap
      scrollHorizontally
      element={WiseOwlElementIds.WISE_OWL_TABLE_BLOCK}
    >
      <THead stickyHeader>
        <Tr>
          {columns.map((column) => (
            <Th key={column}>{column}</Th>
          ))}
        </Tr>
      </THead>

      <TBody>
        {records.map((row, rowIndex) => {
          return (
            <Tr key={rowIndex}>
              {columns.map((column) => {
                // Find matching span property for the current column
                const spanKey = `${column}${SPAN_SUFFIX}`;
                const spanValue = row[spanKey] as number;

                if (spanValue === 0) {
                  return null;
                }

                return (
                  <Td key={column} rowSpan={spanValue}>
                    {row[column]}
                  </Td>
                );
              })}
            </Tr>
          );
        })}
      </TBody>
    </Table>
  );
};

export default TableRenderer;
